import * as Tone from "tone";

export async function initAudio() {
  // Required: Tone won't start until user interacts
  await Tone.start();
  console.log("Audio ready");
}

export const volume = new Tone.Gain(1.5).toDestination();

export const piano = new Tone.Sampler({
  urls: {
    A0: "A0.mp3",
    C1: "C1.mp3",
    "D#1": "Ds1.mp3",
    "F#1": "Fs1.mp3",
    A1: "A1.mp3",
    C2: "C2.mp3",
    "D#2": "Ds2.mp3",
    "F#2": "Fs2.mp3",
    A2: "A2.mp3",
    C3: "C3.mp3",
    "D#3": "Ds3.mp3",
    "F#3": "Fs3.mp3",
    A3: "A3.mp3",
    C4: "C4.mp3",
    "D#4": "Ds4.mp3",
    "F#4": "Fs4.mp3",
    A4: "A4.mp3",
    C5: "C5.mp3",
    "D#5": "Ds5.mp3",
    "F#5": "Fs5.mp3",
    A5: "A5.mp3",
    C6: "C6.mp3",
    "D#6": "Ds6.mp3",
    "F#6": "Fs6.mp3",
    A6: "A6.mp3",
    C7: "C7.mp3",
    "D#7": "Ds7.mp3",
    "F#7": "Fs7.mp3",
    A7: "A7.mp3",
    C8: "C8.mp3",
  },
  release: 1,
  baseUrl: "https://tonejs.github.io/audio/salamander/",
  onload: () => {
    console.log("Piano samples loaded!");
    pianoReady = true;
  },
}).connect(volume);
export let pianoReady = false;
const dry = new Tone.Gain(1);
const wet = new Tone.Gain(0);

piano.connect(dry).connect(volume);

const reverb = new Tone.Reverb({ decay: 2, wet: 1 });
piano.connect(reverb).connect(wet).connect(volume);

export const audioState = {
  sustainOn: false,
  heldNotes: new Set(),
  activeKeys: {},
};

export const baseOctave = 4;

export const keyOrder = [
  "a",
  "w",
  "s",
  "e",
  "d",
  "f",
  "t",
  "g",
  "y",
  "h",
  "u",
  "j",
  "k",
];

export const keyMap = {
  a: { note: "C", offset: 0 },
  w: { note: "C#", offset: 0 },
  s: { note: "D", offset: 0 },
  e: { note: "D#", offset: 0 },
  d: { note: "E", offset: 0 },
  f: { note: "F", offset: 0 },
  t: { note: "F#", offset: 0 },
  g: { note: "G", offset: 0 },
  y: { note: "G#", offset: 0 },
  h: { note: "A", offset: 0 },
  u: { note: "A#", offset: 0 },
  j: { note: "B", offset: 0 },
  k: { note: "C", offset: 1 }, // top C is next octave
};

export function noteForKey(key, octave = baseOctave) {
  const entry = keyMap[key];
  if (!entry) return null;
  return `${entry.note}${octave + (entry.offset || 0)}`;
}
